import {
  createApi,
  fetchBaseQuery,
  type FetchBaseQueryError
} from "@reduxjs/toolkit/query/react";

export interface AppVersionResponse {
  version: string;
  commit: string;
  buildAt: string;
  breaking: boolean;
}

const resolveBaseUrl = () => {
  const base = import.meta.env.BASE_URL ?? "/";
  if (typeof window !== "undefined") {
    const url = new URL(base, window.location.origin);
    return url.pathname.endsWith("/") ? url.toString() : `${url.toString()}/`;
  }
  return base;
};

const baseUrl = resolveBaseUrl();

export const appVersionApi = createApi({
  reducerPath: "appVersionApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    credentials: "same-origin",
    prepareHeaders: headers => {
      headers.set("Cache-Control", "no-cache, no-store, must-revalidate");
      headers.set("Pragma", "no-cache");
      headers.set("Expires", "0");
      return headers;
    },
    fetchFn: async (input, init) => {
      return fetch(input, {
        cache: "no-store",
        ...init,
        headers: {
          "Cache-Control": "no-cache, no-store, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
          ...(init?.headers ?? {})
        }
      });
    }
  }),
  endpoints: builder => ({
    getAppVersion: builder.query<AppVersionResponse, void>({
      serializeQueryArgs: ({ endpointName }) => endpointName,
      queryFn: async (_arg, _queryApi, _extraOptions, fetchWithBQ) => {
        const result = await fetchWithBQ({
          url: "version.json",
          params: {
            t: Date.now()
          }
        });
        if (result.error) {
          return { error: result.error as FetchBaseQueryError };
        }
        return { data: result.data as AppVersionResponse };
      }
    })
  })
});

export const { useGetAppVersionQuery, useLazyGetAppVersionQuery } = appVersionApi;
